import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInstagram,
  faFacebookSquare,
  faLinkedin,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";

import InlineSvg from "vue-inline-svg";

import {
  faCaretRight,
  faDownload,
  faSyncAlt,
  faTimes,
  faToggleOff,
  faToggleOn,
  faChevronLeft,
  faBars,
  faCaretDown,
  faCaretLeft,
  faCalendarPlus,
  faCalendarMinus
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";
import axios from "axios";
import VCalendar from "v-calendar";
import vClickOutside from "v-click-outside";

import InputField from "./components/InputField.vue";
import SingleSelectField from "./components/SingleSelectField.vue";
import ChoicesField from "./components/ChoicesField.vue";
import FlashMessage from "./components/FlashMessage.vue";
import Swal from "sweetalert2";

import container from "./services";
import { PageModule } from "./types";

// resolve the bugsnag service to get it hooked up right away
container.resolve("bugreporter");
container.resolve("bus");

// inject the authenticated user's timezone into all vue components
Vue.prototype.$timezone = window.TUTORCHEST.timezone;

// load plugins
Vue.use(VCalendar);
Vue.use(vClickOutside);

// configure font-awesome for Vue.js
library.add(
  faLinkedin,
  faInstagram,
  faFacebookSquare,
  faTwitter,
  faDownload,
  faTimes,
  faCalendarPlus,
  faCalendarMinus,
  faBars,
  faCaretDown,
  faSyncAlt,
  faCaretDown,
  faCaretRight,
  faCaretLeft,
  faChevronLeft,
  faToggleOn,
  faToggleOff
);

Vue.component("InlineSvg", InlineSvg);
Vue.component("FontAwesomeIcon", FontAwesomeIcon);
Vue.component("InputField", InputField);
Vue.component("SingleSelectField", SingleSelectField);
Vue.component("ChoicesField", ChoicesField);

// Disable production tips in console
Vue.config.productionTip = false;

export const bootPage = (module: PageModule) => {
  if (module.bootstrap) {
    module.bootstrap.call(undefined);
  }

  // Load and mount the page component
  new Vue({
    extends: module.PageComponent,
    propsData: window.TUTORCHEST.propsData,
    data() {
      return {
        menuIsOpen: false,
        menuParentsIsOpen: false,
        menuTutorsIsOpen: false,
        menuCorporateIsOpen: false,
        menuAboutIsOpen: false,
        menuResourcesIsOpen: false,
        menuSchoolsIsOpen: false
      };
    },
    methods: {
      showParentSubscriptionModal() {
        const content = document.querySelector(
          "#parentSubscriptionModalContent"
        )?.innerHTML;
        // Use sweetalert2
        Swal.fire({
          title:
            "<span class='text-lg lg:text-2xl'>Become a Tutor Chest Member</span>",
          html: content,
          showCancelButton: false,
          showConfirmButton: false
        });
      }
    },
    components: {
      FlashMessage
    }
  }).$mount("#app");
};
